import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import PostsAPI from "../../../api/PostsAPI";
import { resolveFileUrl } from "constants/config";
import axios from "axios";

import { Button } from "../../ui-kit/styled-templates";
import { Sidebar } from "arui-feather/sidebar";
import UpdatePostForm from "../tools/UpdatePostForm";
import toast from "react-hot-toast";
import { useStorageListener } from "../../../hooks/useStorage";
import Select from "react-select";
import Tabs from "../../ui/Tabs";
import check_news from "./check_news.svg";
import exclamation_image from "./exclamation-mark.svg";

export function renderPosts(posts, canEdit, onSelect, showAuthorInfo = true) {
    return posts.map((a, i) => {
        return (
            <PostItem key={i}>
                <PostAvatar src={resolveFileUrl(a.avatar)} onClick={() => {
                    if (a.url != undefined && a.url != "") {
                        window.open(a.url, "_blank");
                    }
                    if (canEdit == false){
                        onSelect(a.id);
                    }
                }}>
                </PostAvatar>
                <PostContentPlaceholder>
                    {showAuthorInfo && a.author && (
                        <AuthorInfo>
                            <AuthorAvatar src={resolveFileUrl(a.author.photo || a.author.avatar)} />
                            <AuthorDetails>
                                <AuthorName
                                    onClick={() => window.open(`/ambassadors/${a.author.id}`, "_blank")}
                                    style={{ cursor: 'pointer', color: '#02bf89' }}
                                >
                                    {a.author.name || `${a.author.firstName || ''} ${a.author.lastName || ''}`.trim()}
                                </AuthorName>
                                <AuthorEmail>{a.author.email}</AuthorEmail>
                            </AuthorDetails>
                        </AuthorInfo>
                    )}
                    <PostName onClick={() => {
                        if (a.url != undefined && a.url != "") {
                            window.open(a.url, "_blank");
                        }
                    }}>
                        {a.name}
                        {canEdit == false ? null :
                            <span style={{ marginLeft: 5 }}>
                                            {a.isModerated != true ?
                                                <div style={{ color: "red", fontSize: '12px', fontWeight: 'default' }}>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}>
                                                        <img src={exclamation_image} style={{
                                                            height: "15px",
                                                            display: "inline-block",
                                                            marginRight: 5
                                                        }} />
                                                        <span>
                                                            модерация не пройдена
                                                        </span>
                                                    </div>
                                                    {(a.moderationComment == undefined || a.moderationComment == "") ? null :
                                                        <div>
                                                            {a.moderationComment}
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                <img src={check_news}
                                                     style={{ height: "15px", display: "inline-block" }} />
                                            }
                                        </span>
                        }
                    </PostName>
                    <PostDescription onClick={() => {
                        if (a.url != undefined && a.url != "") {
                            window.open(a.url, "_blank");
                        }

                    }}>
                        {a.description == undefined ? '' : a.description.length > 100 ? a.description.substring(0, 100) + "..." : a.description}
                    </PostDescription>
                    {canEdit == false ? null :
                        <div>
                                        <span style={{ fontSize: "12px", marginTop: 8, color: 'blue' }} onClick={() => {
                                            onSelect(a.id);
                                        }}>
                                            редактировать
                                        </span>
                        </div>
                    }

                </PostContentPlaceholder>
            </PostItem>
        );
    });
}

export default function AdminPostsPanel(props) {
    const {
        userId,
        canEdit = true
    } = props;

    const [posts, setPosts] = useState([]);
    const [ambassadors, setAmbassadors] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedId, setSelectedId] = useState(undefined);

    const [addVisible, setAddVisible] = useState(false);

    const uData = useStorageListener("user", {});

    // Функция для обогащения постов информацией об авторах
    const enrichPostsWithAuthors = (postsData, ambassadorsList) => {
        return postsData.map(post => {
            const author = ambassadorsList.find(amb => amb.id === post.userId);
            return {
                ...post,
                author: author ? {
                    id: author.id,
                    name: author.name,
                    firstName: author.firstName,
                    lastName: author.lastName,
                    email: author.email,
                    photo: author.photo,
                    avatar: author.avatar
                } : null
            };
        });
    };

    // Функция для загрузки и обогащения постов
    const loadPosts = async () => {
        const postsData = await PostsAPI.getAllPosts(userId);
        const enrichedPosts = enrichPostsWithAuthors(postsData, ambassadors);
        setPosts(enrichedPosts);
    };

    useEffect(() => {
        if (loading == true) {
            return;
        }
        setLoading(true);

        Promise.all([
            PostsAPI.getAllPosts(userId),
            axios.get("/ambassadors/all")
        ]).then(([postsData, ambassadorsData]) => {
            const ambassadorsList = ambassadorsData.data;
            const enrichedPosts = enrichPostsWithAuthors(postsData, ambassadorsList);

            setPosts(enrichedPosts);
            setAmbassadors(ambassadorsList);
            setLoading(false);
        }).catch(err => {
            console.error('Error loading posts or ambassadors:', err);
            setLoading(false);
        });
    }, [userId]);

    if (posts.length == 0 && loading == true) {
        return (
            <div>
                загрузка...
            </div>
        );
    }

    let currentUserIsAdmin = (uData?.userRole == "admin");

    let selectedPost = (selectedId == undefined) ? undefined : posts.find(a => a.id == selectedId);

    let fPosts = posts;

    // if (showtPostsOnModeration == false) {
    //     fPosts = fPosts.filter(x => x.isModerated == true);
    // }
    // if (showOption == "on_moderation") {
    //     fPosts = fPosts.filter(x => x.isModerated != true);
    // }
    //
    // if (showOption == "published") {
    //     fPosts = fPosts.filter(x => x.isModerated == true);
    // }


    return (
        <Wrapper>

            <Tabs
                tabs={[
                    {
                        label: "На модерации",
                        content: <PostsPlaceholder>
                            {renderPosts(fPosts.filter(x => x.isModerated != true), canEdit, setSelectedId, true)}
                        </PostsPlaceholder>
                    },
                    {
                        label: "Опубликовано",
                        content: <PostsPlaceholder>
                            {renderPosts(fPosts.filter(x => x.isModerated == true), canEdit, setSelectedId, true)}
                        </PostsPlaceholder>
                    }
                ]}
            />


            <Sidebar width={Math.min(820, window.innerWidth)} visible={addVisible} onCloserClick={() => {
                setAddVisible(false);
            }}>

                {addVisible == false ? null :
                    <div>

                        <UpdatePostForm
                            isAdmin={currentUserIsAdmin}
                            loading={loading}
                            onSave={async d => {
                                setLoading(true);
                                await PostsAPI.createPost({
                                    ...d,
                                    userId: userId
                                });
                                await loadPosts();
                                setLoading(false);
                                toast.success("Изменения сохранены");
                                setAddVisible(false);
                            }}
                        />

                    </div>
                }

            </Sidebar>

            <Sidebar width={Math.min(820, window.innerWidth)} visible={(selectedPost != undefined)}
                     onCloserClick={() => {
                         setSelectedId(undefined);
                     }}>

                {selectedPost == undefined ? null :
                    <div>

                        <UpdatePostForm
                            isAdmin={currentUserIsAdmin}
                            canDelete={true}
                            {...selectedPost}
                            loading={loading}
                            onSave={async d => {
                                setLoading(true);
                                await PostsAPI.updatePost({
                                    ...d,
                                    id: selectedPost.id
                                });
                                await loadPosts();
                                setLoading(false);
                                toast.success("Изменения сохранены");
                            }}
                            onDelete={async () => {
                                setLoading(true);
                                await PostsAPI.deletePost(selectedPost?.id);
                                await loadPosts();
                                setSelectedId(undefined);
                                toast.success("Пост удален");
                                setLoading(false);
                            }}
                        />

                    </div>
                }

            </Sidebar>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const AddPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const PostsPlaceholder = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;

const PostItem = styled.div`
  margin: 10px;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid rgb(227, 236, 244);

  :hover {
    opacity: 0.7;
  }
`;

const PostAvatar = styled.div`
  width: 100%;
  height: 200px;
  margin-bottom: 10px;
  box-sizing: border-box;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url("${({ src }) => src}");
`;

const PostContentPlaceholder = styled.div`
  box-sizing: border-box;
  padding: 20px;
`;

const PostName = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
`;

const PostDescription = styled.div`
  font-size: 13px;
  line-height: 18px;
`;

const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 12px;
`;

const AuthorAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: url("${({ src }) => src}");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #ddd;
  flex-shrink: 0;
`;

const AuthorDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const AuthorName = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    text-decoration: underline;
  }
`;

const AuthorEmail = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;